import {
    Button,
    CircularProgress,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    styled,
} from '@mui/material';
import AppModal from 'components/AppModal';
import { H2 } from 'components/Typography';
import FormatDate from 'utils/formatDate';

const StyledAppModal = styled(AppModal)(({ theme }) => ({
    maxWidth: 800,
    minWidth: 600,
    [theme.breakpoints.down(325)]: {
        maxWidth: '100%',
    },
    textAlign: 'center',
}));

const AlreadyRegisteredConfirmation = ({
    open,
    onClose,
    data,
    title,
    onConfirm,
    loading = true,
}) => {
    return (
        <StyledAppModal open={open} handleClose={onClose}>
            <H2>{title}</H2>
            <H2>{data?.nickName}</H2>
            {data?.registrationDate && (
                <H2 mb={0}>{`On ${FormatDate(data?.registrationDate, 'dd MMMM yyyy HH:mm')}`}</H2>
            )}
            <Typography align="left">Participant Information:</Typography>
            <Table
                size="small"
                sx={{
                    borderBottom: '1px solid rgba(0,0,0,0.1)',
                }}
                aria-label="caption table"
            >
                <TableBody>
                    <TableRow sx={{ border: 'none' }}>
                        <TableCell
                            sx={{
                                width: '150px',
                            }}
                        >
                            <Typography>Profession</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>: {data?.profession}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell
                            sx={{
                                width: '150px',
                            }}
                        >
                            <Typography>Phone Number</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>: {data?.phoneNumber}</Typography>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell
                            sx={{
                                width: '150px',
                            }}
                        >
                            <Typography>Institution</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>: {data?.institution}</Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
            <Typography align="left" sx={{ mt: 4 }}>
                Package Information:
            </Typography>
            <Table
                size="small"
                sx={{
                    borderBottom: '1px solid rgba(0,0,0,0.1)',
                    mb: 4,
                }}
                aria-label="caption table"
            >
                <TableHead
                    sx={{
                        fontWeight: 'bold',
                    }}
                >
                    <TableRow>
                        <TableCell>
                            <Typography>No</Typography>
                        </TableCell>
                        <TableCell
                            sx={{
                                width: '150px',
                                textAlign: 'left',
                                verticalAlign: 'top',
                            }}
                        >
                            <Typography>Invoice Number</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>Package</Typography>
                        </TableCell>
                        <TableCell>
                            <Typography>Workshop</Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.invoices?.map((item, index) => (
                        <TableRow
                            sx={{
                                textAlign: 'left',
                                verticalAlign: 'top',
                            }}
                            key={index}
                        >
                            <TableCell>
                                <Typography>{index + 1}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography>{item?.number}</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography>{item?.package}</Typography> 
                            </TableCell>
                            <TableCell>
                                {item.workshops.length !== 0 ? (
                                    <ul style={{ margin: 0, paddingLeft: '1.2em' }}>
                                        {item.workshops.map((data, i) => (
                                            <li key={i}>
                                                <Typography component="span">{data}</Typography>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <Typography>Not Include Workshop</Typography>
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Button
                fullWidth
                size="small"
                variant="contained"
                onClick={onConfirm}
                disabled={loading}
                startIcon={
                    loading ? (
                    <CircularProgress size={16} color="inherit" />
                    ) : undefined
                }
            >
                {title === 'Re-Register Successfully'
                    ? loading
                        ? 'Printing...'
                        : 'Print Badge'
                    : 'Confirm'}
            </Button>
        </StyledAppModal>
    );
};

export default AlreadyRegisteredConfirmation;
